import DataType from '../models/dataTypes/DataType'

const dataTypeUtils = {
  isCompatible(a: DataType, b: DataType): boolean {
    return a.symbol === b.symbol
  }
}

export default dataTypeUtils
